import React, { useState } from "react";
import { useParams, withRouter, Link } from "react-router-dom";
import { Wrapper } from "@networkraildigitalfactory/components";
import styles from "./MyObjectives.module.css";
import ObjectivesContent from "../ObjectivesContent/ObjectivesContent";
import TabTable from "../TabTable/TabTable";
import PageTitle from "../PageTitle/PageTitle";

const MyObjectives = (props) => {
  const { history, setObjectivesFilters, objectivesFilters } = props;
  const params = useParams();

  const toNewPage = (path) => {
    history.push(path);
  };

  const objectiveTab = {
    titleButtonText: "add new objective",
    titleButtonOnClick: () => toNewPage("/new-objective"),
  };

  const pdpTab = {
    titleButtonText: "add new development goal",
    titleButtonOnClick: () => toNewPage("/new-development-goal"),
  };

  const [currentlyViewing, setCurrentlyViewing] = useState(
    history.location.pathname === "/my-objectives/PDP" ? pdpTab : objectiveTab
  );
  const { titleButtonText, titleButtonOnClick } = currentlyViewing;

  const clearFilters = () => {
    setObjectivesFilters("dueDate", "");
    setObjectivesFilters("status", "");
    setObjectivesFilters("page", 1);
  };

  const onChangeTab = (tab) => {
    switch (tab) {
      case "myobjectives":
        setCurrentlyViewing(objectiveTab);
        clearFilters();
        break;
      case "pdp":
        setCurrentlyViewing(pdpTab);
        clearFilters();
        break;
      default:
        break;
    }
  };

  const tabsList = [
    {
      name: "My Objectives",
      data: (
        <div id="myobjectivesPanel">
          <ObjectivesContent
            isLineManagerView={false}
            setObjectivesFilters={setObjectivesFilters}
            objectivesFilters={objectivesFilters}
          />
        </div>
      ),
    },
    {
      name: "PDP",
      data: (
        <div id="pdpPanel">
          <ObjectivesContent
            isLineManagerView={false}
            setObjectivesFilters={setObjectivesFilters}
            objectivesFilters={objectivesFilters}
            type="PDP"
          />
        </div>
      ),
    },
  ];

  let defaultActive;
  if (params.defaultTab === "objectives") {
    defaultActive = "myobjectives";
  } else {
    defaultActive = params.defaultTab.toLowerCase();
  }

  const paragraph = (
    <>
      <p>This is where you will record and manage your objectives and Personal Development Plan.</p>
      <p>
        {" "}
        You will be able to edit your objectives here, as well as mark any as complete and provide
        comments on your objectives.
      </p>
      <p>
        Haven’t had an End of Year review and need to close out last year’s objectives? Click{" "}
        <Link style={{ color: "#37519D", textDecoration: "underline" }} to="/close-objectives">
          here
        </Link>
      </p>
    </>
  );

  return (
    <Wrapper maxWidth={1375} align="center">
      <PageTitle
        titleHeader="My Objectives"
        titleParagraph={paragraph}
        buttonText={titleButtonText}
        enableSkip
        startReviewPrep={titleButtonOnClick}
      />
      <div className={styles.tab_container}>
        <TabTable
          style={{ fontSize: "18px" }}
          tabs={tabsList}
          defaultActive={defaultActive}
          onChangeTab={onChangeTab}
        />
      </div>
    </Wrapper>
  );
};

export default withRouter(MyObjectives);
